var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#628BF5",
    d: "M1.125 0h7.808c.029.01.056.025.086.03.896.164 1.586.916 1.63 1.822.028.582.013 1.166.014 1.75 0 .165.003.333-.013.498-.029.287-.266.52-.55.558-.437.06-.769-.236-.773-.703-.005-.63.001-1.26-.002-1.89-.003-.465-.266-.725-.727-.725h-2.78c-.043 0-.086.004-.133.006.159.09.322.161.458.265.378.292.525.69.525 1.162-.004 3.224-.002 6.448-.002 9.671 0 .07.006.14.01.216.7 0 1.381.007 2.062-.004.28-.004.532-.255.573-.532.012-.088.015-.177.015-.265.001-.834-.004-1.667.002-2.5.003-.398.284-.687.654-.696.366-.01.675.278.678.668.007.943.023 1.886-.013 2.828-.038 1.017-.93 1.837-1.946 1.842-.62.003-1.238 0-1.858 0h-.177c0 .1.002.178 0 .255-.009.228.013.463-.033.684-.168.813-.97 1.249-1.778.981-1.305-.432-2.61-.866-3.912-1.304-.478-.162-.787-.491-.91-.986-.007-.023-.021-.045-.032-.067L0 1.125c.012-.039.025-.077.036-.116.118-.419.37-.722.768-.9.102-.046.214-.073.32-.109z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1AC1B1",
    d: "M11.994 7.34h-.203l-2.436-.001c-.284 0-.503-.126-.63-.384-.12-.247-.087-.487.08-.703.133-.17.312-.251.53-.251H11.993v-.173V4.03c-.002-.303.13-.527.405-.643.275-.116.532-.06.745.154.885.883 1.77 1.765 2.65 2.652.27.272.277.668.008.94-.886.896-1.777 1.786-2.672 2.674-.206.205-.463.257-.733.139-.269-.118-.403-.334-.403-.63V7.34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.e0a412f7262d0d6c9f8afa43c0a090ed.svg";
export { ForwardRef as ReactComponent };